import { debounce, fetchConfig } from '@utils';

/**
 * CartNote
 * @description Update cart note.
 */
class CartNote extends HTMLElement {
  connectedCallback() {
    this.addEventListener(
      'change',
      debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300)
    );
  }
}
customElements.define('cart-note', CartNote);
